export const sampleSuperAdminInsights = {
  kpiData: {
    totalOrganisations: 150,
    totalUsers: 5000,
    totalActiveSubscriptions: 120,
    totalRevenue: 75000,
    averageRevenuePerOrg: 500,
    activeSpaces: 450
  },
  organisationsByStatus: [
    { status: 'Active', count: 120 },
    { status: 'Pending', count: 15 },
    { status: 'Inactive', count: 10 },
    { status: 'Suspended', count: 5 }
  ],
  userGrowthData: [
    { date: '2024-01', users: 4000 },
    { date: '2024-02', users: 4300 },
    { date: '2024-03', users: 4700 },
    { date: '2024-04', users: 5000 }
  ],
  spacesByTypeData: [
    { type: 'Tennis', count: 200 },
    { type: 'Basketball', count: 100 },
    { type: 'Football', count: 80 },
    { type: 'Swimming', count: 70 }
  ],
  subscriptionsByTypeData: [
    { type: 'Basic', count: 50 },
    { type: 'Pro', count: 40 },
    { type: 'Enterprise', count: 30 }
  ],
  mrrTrendData: [
    { date: '2024-01', amount: 60000 },
    { date: '2024-02', amount: 65000 },
    { date: '2024-03', amount: 70000 },
    { date: '2024-04', amount: 75000 }
  ],
  planInsightsData: [
    { name: 'Basic', organisations: 50 },
    { name: 'Pro', organisations: 40 },
    { name: 'Enterprise', organisations: 30 }
  ]
}; 
